// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Xp8CrA1ZCCZdujixWTfmxg\\=\\={opacity:.4}.Xp8CrA1ZCCZdujixWTfmxg\\=\\=:hover{cursor:not-allowed !important}", "",{"version":3,"sources":["webpack://./src/components/MultiDropdown/subcomponents/DropdownItem/DropdownItem.module.scss"],"names":[],"mappings":"AAAA,4BACE,UAAA,CAEA,kCACE,6BAAA","sourcesContent":[".disabled {\n  opacity: 0.4;\n\n  &:hover {\n    cursor: not-allowed !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"disabled": "Xp8CrA1ZCCZdujixWTfmxg=="
};
export default ___CSS_LOADER_EXPORT___;
